import ICustomForm from "../../ICustomForm";
import m from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import {CheckboxItem} from "../../../model/items/checkbox";
import CheckboxList from "../CheckboxList";
import CheckboxCell from "../../shared/components/FormCell/CheckboxCell";

/**
 * Checkbox list
 *
 * Transform form with checkbox list
 */
export default class CheckboxListDefault extends CheckboxList implements ICustomForm {

    private readonly checkboxCells: CheckboxCell[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);

        for (const cell of this.settings.form.grid.cells) {
            for (let cellItem of cell.cellItems) {
                if (cellItem instanceof CheckboxItem) {
                    this.checkboxCells[cell.row] = new CheckboxCell(
                        cell,
                        this.onSetValue.bind(this),
                        () => { this.settings.nextForm(); }
                    );
                }
            }
        }
    }

    public checkRequirements(): boolean {
        if (this.checkboxCells.length === 0) {
            console.log('customForm-CheckboxList-default: missing checkboxes');
            return false;
        }

        return true;
    }

    public view() {

        const inputs = this.checkboxCells.map(c => m(c));

        if (this.heroImage) {
            inputs.unshift(this.viewHeroImage()!);
        }
        const videoView = this.viewHeroVideo();
        if (this.videoItem && videoView) {
            inputs.unshift(videoView);
        }

        return this.viewLayout(m("form", {}, inputs));
    };
}
